import type { ReactNode } from "react"

import { useFlash } from "@/hooks/use-flash"

import { Toaster } from "@/components/ui/sonner"

interface MarketingPersistentLayoutProps {
  children: ReactNode
}

export default function MarketingPersistentLayout({
  children,
}: MarketingPersistentLayoutProps) {
  useFlash()

  return (
    <>
      {children}
      <Toaster richColors />
    </>
  )
}
